$(document).ready(function () {
    $('select.select2').each(function () {
        $(this)
            .select2({
                allowClear: true,
                placeholder: $(this).children().first().text(),
                theme: 'bootstrap',
            })

            // Focus on input when opening select.
            // @link https://github.com/select2/select2/issues/5993
            .on('select2:open', () => {
                document.querySelector('.select2-container--open .select2-search__field').focus();
            })

            // Close dropdown on clear.
            // @link https://github.com/select2/select2/issues/3320#issuecomment-223588626
            .on('select2:unselecting', () => {
                $(this).data('unselecting', true);
            })
            .on('select2:open', () => {
                if ($(this).data('unselecting')) {
                    $(this).select2('close').removeData('unselecting');
                }
            });
    });
});
